import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";

import clsx from "clsx";

import { makeStyles, Paper, useMediaQuery, Grid, Button } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import { Robot } from "@phosphor-icons/react";

import ContactDrawer from "../ContactDrawer";
import MessageInput from "../MessageInput/";
import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";
import TicketActionButtons from "../TicketActionButtonsCustom";
import MessagesList from "../MessagesList";
import api from "../../services/api";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageProvider } from "../../context/ForwarMessage/ForwardMessageContext";

import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TagsContainer } from "../TagsContainer";
import { isNil } from 'lodash';
import { EditMessageProvider } from "../../context/EditingMessage/EditingMessageContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import whatsBackground from "../../assets/wa-background.png";
import whatsBackgroundDark from "../../assets/wa-background-dark.png";

const drawerWidth = 400;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },

  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    border: "0",
    borderRadius: "15px !important",
    margin: "0",
    marginRight: -drawerWidth,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
  },

  mainWrapperShift: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
  },
  tagManagesTicket: {
    backgroundColor: theme.mode === 'light' ? `#DCE6FF` : `#08080c`,
    padding: "6px 10px",
    borderRadius: 0,
  },
}));

const Ticket = () => {
  const { ticketId } = useParams();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles();

  const { user, socket } = useContext(AuthContext);
  const { setTabOpen } = useContext(TicketsContext);


  const [drawerOpen, setDrawerOpen] = useState(!isMobile);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});
  const [dragDropFiles, setDragDropFiles] = useState([]);
  const companyId = user?.companyId;

  useEffect(() => {
    if (!isMobile) {
      setDrawerOpen(true);
    } else {
      setDrawerOpen(false);
    }
  }, [ticketId, isMobile]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {

          if (!isNil(ticketId) && ticketId !== "undefined") {

            const { data } = await api.get("/tickets/u/" + ticketId);

            setContact(data.contact);
            // setWhatsapp(data.whatsapp);
            // setQueueId(data.queueId);
            setTicket(data);
            if (["pending", "open", "group"].includes(data.status)) {
              setTabOpen(data.status);
            }
            setLoading(false);
          }
        } catch (err) {
          history.push("/tickets");   // correção para evitar tela branca uuid não encontrado Feito por Altemir 16/08/2023
          setLoading(false);
          toastError(err);
        }
      };
      fetchTicket();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [ticketId, user, history]);

  useEffect(() => {
    if (!ticket?.id && ticket?.uuid !== ticketId && ticketId === "undefined") {
      return;
    }

    if (user?.companyId) {
      //    const socket = socketManager.GetSocket();

      const onConnectTicket = () => {
        if (ticket?.id) socket.emit("joinChatBox", `${ticket.id}`);
      }

      const onCompanyTicket = (data) => {
        if (data.action === "update" && data.ticket?.id === ticket?.id) {
          setTicket(data.ticket);
        }

        if (data.action === "delete" && data.ticketId === ticket?.id) {
          history.push("/tickets");
        }
      };

      const onCompanyContactTicket = (data) => {
        if (data.action === "update") {
          // if (isMounted) {
          setContact((prevState) => {
            if (prevState?.id === data.contact?.id) {
              return { ...prevState, ...data.contact };
            }
            return prevState;
          });
          // }
        }
      };

      socket.on("connect", onConnectTicket)
      socket.on(`company-${companyId}-ticket`, onCompanyTicket);
      socket.on(`company-${companyId}-contact`, onCompanyContactTicket);

      return () => {
        if (ticket?.id) {
          socket.emit("joinChatBoxLeave", `${ticket.id}`);
        }
        socket.off("connect", onConnectTicket);
        socket.off(`company-${companyId}-ticket`, onCompanyTicket);
        socket.off(`company-${companyId}-contact`, onCompanyContactTicket);
      };
    }
  }, [ticketId, ticket, history]);

  const handleDrawerOpen = useCallback(() => {
    setDrawerOpen((prev) => !prev);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);

  const handleQuickMessageSelect = (quickMessage) => {
    try {
      if (quickMessage.message) {
        // Disparar evento que o MessageInput vai escutar
        const event = new CustomEvent('insertQuickMessage', {
          detail: { message: quickMessage.message }
        });
        window.dispatchEvent(event);
        
      }
      
      if (quickMessage.mediaPath) {
        // Tratar mídia se necessário
      }
    } catch (error) {
      console.error("Erro ao inserir resposta rápida:", error);
      toastError("Erro ao inserir resposta rápida");
    }
  };

  const handleStopFlow = async () => {
    try {
      await api.put(`/tickets/${ticket.id}`, {
        isBot: false,
        useIntegration: false,
        flowWebhook: false,
        flowStopped: null,
        lastFlowId: null,
        hashFlowId: null,
        dataWebhook: null
      });
      setTicket((prev) => ({
        ...prev,
        isBot: false,
        useIntegration: false,
        flowWebhook: false,
        flowStopped: null,
        lastFlowId: null,
        hashFlowId: null,
        dataWebhook: null
      }));
      toast.success("Fluxo de conversa parado com sucesso!");
    } catch (err) {
      toastError(err);
    }
  };

  const renderMessagesList = () => {
    return (
      <>
        <MessagesList
          isGroup={ticket?.isGroup}
          onDrop={setDragDropFiles}
          whatsappId={ticket?.whatsappId}
          queueId={ticket?.queueId}
          channel={ticket?.channel}
          ticketStatus={ticket?.status}
        >
        </MessagesList>
        <MessageInput
          ticketId={ticket?.id}
          ticketStatus={ticket?.status}
          ticketChannel={ticket?.channel}
          droppedFiles={dragDropFiles}
          contactId={contact?.id}
          whatsappId={ticket?.whatsappId}
        />
      </>
    );
  };


  return (
    <div className={classes.root} id="drawer-container">
      <Paper
        variant="outlined"
        elevation={0}
        className={clsx(classes.mainWrapper, {
          [classes.mainWrapperShift]: drawerOpen && !isMobile,
        })}
      >
        {/* <div id="TicketHeader"> */}
        <TicketHeader loading={loading}>
          <div id="TicketHeader" style={{ width: "100%" }}>
            <Grid container spacing={10} alignItems="center">
              <Grid item xs={6}>
                {ticket?.contact !== undefined && (
                  <TicketInfo
                    contact={contact}
                    ticket={ticket}
                    onClick={handleDrawerOpen}
                  />
                )}
              </Grid>
              <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <TicketActionButtons
                  ticket={ticket}
                  contact={contact}
                  onQuickMessageSelect={handleQuickMessageSelect}
                />
              </Grid>
            </Grid>
          </div>
        </TicketHeader>
        {/* </div> */}
        {ticket?.isBot && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 16px",
              backgroundColor: theme.mode === "light" ? "#E8F5E9" : "#132316",
              borderBottom: `1px solid ${theme.mode === "light" ? "#C8E6C9" : "#1e3d24"}`,
              color: theme.mode === "light" ? "#2E7D32" : "#81C784",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Robot size={20} weight="bold" />
              <span>
                <strong>Fluxo de conversa:</strong> Ativo
              </span>
            </div>
            <Button
              size="small"
              variant="contained"
              color="secondary"
              style={{
                textTransform: "none",
                fontWeight: 600,
                fontSize: "12px",
                borderRadius: "8px",
                boxShadow: "none",
              }}
              onClick={handleStopFlow}
            >
              Parar fluxo de conversa
            </Button>
          </div>
        )}
        <Paper className={classes.tagManagesTicket}>
          <TagsContainer className={classes.tagManagesTicket} contact={contact} />
        </Paper>
        <ReplyMessageProvider>
          <ForwardMessageProvider>
            <EditMessageProvider>
              {renderMessagesList()}
            </EditMessageProvider>
          </ForwardMessageProvider>
        </ReplyMessageProvider>
      </Paper>

      <ContactDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        contact={contact}
        loading={loading}
        ticket={ticket}
      />

    </div>
  );
};

export default Ticket;